<template>
  <el-drawer title="我是标题" :visible="show" :size="825">
    <div slot="title" style="background-color: yellow">
      this is title <button>hah</button>
    </div>
    <slot></slot>
  </el-drawer>
</template>

<script>
export default {
  name: "PanelDrawer",
  // emits: ['confirm', 'cancel'],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>

<style scoped lang="less">
.component-container {
}
</style>